/** Neutralize CSV formula injection for Excel. */
export function neutralizeCsvFormula(value: string): string {
  if (/^[=+\-@]/.test(value)) return `'${value}`;
  return value;
}

export function csvEscapeRaw(value: string): string {
  if (value === '') return '';
  if (/[;"\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function csvEscape(value: string): string {
  return csvEscapeRaw(neutralizeCsvFormula(value));
}
